import { Link, type LinkProps } from "react-router";

import type { UserDto } from "@/api/types";
import { UserAvatar } from "@/components/UserAvatar/UserAvatar";
import { useTranslation } from "@/translations";

type QuickReplyMenuBarProps = {
  user: UserDto;
  loginUrl: string | LinkProps["to"];
};

export function QuickReplyMenuBar({ user, loginUrl }: QuickReplyMenuBarProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <header className="flex w-full items-center justify-center border-b border-border-secondary">
      <nav className="flex h-flow-header w-full max-w-xl items-center px-space-md @sm:justify-between">
        <span className="flex h-full items-center justify-center border-border-secondary @sm:w-auto @sm:justify-start @sm:border-r @sm:pr-space-md">
          <span className="flex items-center text-body-emphasis whitespace-nowrap">
            {t("page.messages-email.title")}
          </span>
        </span>
        <Link className="ml-auto flex items-center gap-space-sm text-text-brand transition-colors" to={loginUrl}>
          <UserAvatar image={user.avatar} isUserDeleted={!!user.deletedAt} />
          <span className="text-body-emphasis">{t("page.quick-reply.log-in")}</span>
        </Link>
      </nav>
    </header>
  );
}
